import React, { useState } from 'react';
import { FiPlus, FiEdit2, FiTrash2, FiFolder } from 'react-icons/fi';

const CategoryManager = () => {
  const [categories, setCategories] = useState([
    { id: 1, name: 'Perfume', slug: 'perfume', products: 24 },
    { id: 2, name: 'Body Care', slug: 'body-care', products: 18 },
    { id: 3, name: 'Gift Sets', slug: 'gift-sets', products: 12 }
  ]);
  const [newCategory, setNewCategory] = useState('');
  const [editingId, setEditingId] = useState(null);
  const [editValue, setEditValue] = useState('');

  const handleAddCategory = () => {
    if (newCategory.trim()) {
      setCategories([
        ...categories,
        {
          id: Math.max(...categories.map(c => c.id)) + 1,
          name: newCategory,
          slug: newCategory.toLowerCase().replace(/\s+/g, '-'),
          products: 0
        }
      ]);
      setNewCategory('');
    }
  };

  const handleUpdateCategory = (id) => {
    setCategories(categories.map(cat => 
      cat.id === id ? { ...cat, name: editValue, slug: editValue.toLowerCase().replace(/\s+/g, '-') } : cat
    ));
    setEditingId(null);
  };

  return (
    <div className="bg-white rounded-lg shadow overflow-hidden">
      <div className="px-6 py-4 border-b border-gray-200">
        <h2 className="text-xl font-semibold text-gray-800">Product Categories</h2>
        <p className="text-sm text-gray-500">Organize products into categories</p>
      </div>
      
      <div className="px-6 py-4">
        <div className="flex mb-4">
          <input
            type="text"
            value={newCategory}
            onChange={(e) => setNewCategory(e.target.value)}
            placeholder="New category name"
            className="flex-1 px-3 py-2 border border-gray-300 rounded-l-md focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
          />
          <button
            onClick={handleAddCategory}
            className="px-4 py-2 bg-indigo-600 text-white rounded-r-md hover:bg-indigo-700"
          >
            <FiPlus className="inline mr-1" /> Add
          </button>
        </div>
        
        <div className="overflow-hidden border border-gray-200 rounded-lg">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Category</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Slug</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Products</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {categories.map((category) => (
                <tr key={category.id}>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="flex items-center">
                      <FiFolder className="text-indigo-500 mr-2" />
                      {editingId === category.id ? (
                        <input
                          type="text"
                          value={editValue}
                          onChange={(e) => setEditValue(e.target.value)}
                          className="border border-gray-300 px-2 py-1 rounded"
                        />
                      ) : (
                        <span className="font-medium">{category.name}</span>
                      )}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{category.slug}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{category.products}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                    {editingId === category.id ? (
                      <>
                        <button
                          onClick={() => handleUpdateCategory(category.id)}
                          className="text-green-600 hover:text-green-900 mr-3"
                        >
                          Save
                        </button>
                        <button
                          onClick={() => setEditingId(null)}
                          className="text-gray-500 hover:text-gray-700"
                        >
                          Cancel
                        </button>
                      </>
                    ) : (
                      <>
                        <button
                          onClick={() => {
                            setEditingId(category.id);
                            setEditValue(category.name);
                          }}
                          className="text-indigo-600 hover:text-indigo-900 mr-3"
                        >
                          <FiEdit2 className="inline" />
                        </button>
                        <button
                          onClick={() => setCategories(categories.filter(c => c.id !== category.id))}
                          className="text-red-600 hover:text-red-900"
                        >
                          <FiTrash2 className="inline" />
                        </button>
                      </>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default CategoryManager;